import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams, useNavigate } from "react-router-dom";

import {
  GetSingleDokumen,
  CreateDokumen,
  EditDokumen,
  reset,
} from "../../../features/DokumenSlice";

import Swal from "sweetalert2";
import {
  Card,
  Button,
  Form,
  Col,
  Row,
  Modal,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronCircleLeft,
  faPencilAlt,
} from "@fortawesome/free-solid-svg-icons";

import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";

const FormDokumenPage = () => {
  const [newData, setNewData] = useState({
    nama: "",
    deskripsi: "",
  });

  const dispatch = useDispatch();
  const { data, isLoading, isEdit, isCreate } = useSelector(
    (state) => state.dokumen
  );

  const param = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (id) {
      dispatch(GetSingleDokumen({ id, token }));
    }
    if (isEdit || isCreate) {
      Swal.fire({
        title: "Berhasil",
        showConfirmButton: true,
      }).then((res) => {
        if (res.isConfirmed) {
          navigate(`/master/${param.pathname.split("/")[2]}/list`);
        }
      });
    }
  }, [id, dispatch, token, isEdit, isCreate, navigate, param]);

  useEffect(() => {
    setNewData({
      nama: data?.data?.nama,
      deskripsi: data?.data?.deskripsi,
    });
  }, [data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (id) {
      dispatch(
        EditDokumen({
          id,
          nama: newData.nama,
          deskripsi: newData.deskripsi,
          token,
        })
      );
    } else {
      dispatch(reset());
      dispatch(
        CreateDokumen({
          nama: newData.nama,
          deskripsi: newData.deskripsi,
          token,
        })
      );
    }
  };

  return (
    <AdminLayout>
      {param.pathname.split("/")[3] === "view" ? (
        <>
          <Header>
            <Button
              variant="outline-primary"
              size="sm"
              href={`/${param.pathname.split("/")[1]}/edit/${id}`}
            >
              <FontAwesomeIcon icon={faPencilAlt} className="me-2" />
              Edit
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[3] === "add" ? (
        <>
          <Header>
            <Button
              variant="outline-primary"
              size="sm"
              href={`/${param.pathname.split("/")[1]}/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[3] === "edit" ? (
        <>
          <Header>
            <Button
              variant="outline-primary"
              size="sm"
              href={`/${param.pathname.split("/")[1]}/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : null}
      <ModalLoading isLoading={isLoading} />
      <Card border="light" className="shadow-sm mb-4">
        {param.pathname.split("/")[3] === "view" ? (
          <FormPage
            newData={newData}
            setNewData={setNewData}
            handleSubmit={handleSubmit}
            isLocked={true}
          />
        ) : param.pathname.split("/")[3] === "add" ? (
          <FormPage
            newData={newData}
            setNewData={setNewData}
            handleSubmit={handleSubmit}
          />
        ) : param.pathname.split("/")[3] === "edit" ? (
          <FormPage
            newData={newData}
            setNewData={setNewData}
            handleSubmit={handleSubmit}
          />
        ) : null}
      </Card>
    </AdminLayout>
  );
};

const FormPage = ({
  newData,
  setNewData,
  id,
  isLocked = false,
  handleSubmit,
}) => {
  return (
    <Card.Body>
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={12} className="mb-3">
            <Form.Group id="Nama">
              <Form.Label>Nama</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Nama"
                name="nama"
                disabled={isLocked}
                value={newData.nama || ""}
                onChange={(e) =>
                  setNewData({ ...newData, nama: e.target.value })
                }
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="Deskripsi">
              <Form.Label>Deskripsi</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Deskripsi"
                name="deskripsi"
                disabled={isLocked}
                value={newData.deskripsi || ""}
                onChange={(e) =>
                  setNewData({ ...newData, deskripsi: e.target.value })
                }
              />
            </Form.Group>
          </Col>
        </Row>
        <div>
          {!isLocked ? (
            <Button type="submit">{id ? "Update" : "Simpan"}</Button>
          ) : null}
        </div>
      </Form>
    </Card.Body>
  );
};

const ModalLoading = ({ isLoading }) => {
  return (
    <Modal as={Modal.Dialog} centered show={isLoading}>
      <Modal.Body>
        <p>Loading...</p>
      </Modal.Body>
    </Modal>
  );
};

export default FormDokumenPage;
